console.log('js/show-more.js v0.1.0');

$(function() {
	if ($('[data-showmore-items-limit]').length) {

		$('[data-showmore-items-limit]').each(function() {
			var items = $(this).children();
            var limit = $(this).attr('data-showmore-items-limit');

			/*
			 * If the limit is higher than the amount of items
			 * retur and don't add the expander
			 */

			if (limit >= items.length) {
				return;
			}

			var itemExpander = $('<p class="show-all bttn bttn--outline"></p>');
            var moreText = ( $(this).attr('data-showmore-text') ? $(this).attr('data-showmore-text') : "Show more");
            var lessText = ( $(this).attr('data-showless-text') ? $(this).attr('data-showless-text') : "Show less");

			$(itemExpander).append(moreText);

			$(this).addClass('collapsed');

			for (var i = 0; i < items.length; i++) {
				if (i >= limit) {
					items[i].classList.add('hidden');
				}
			}

			itemExpander.insertAfter($(this));
		});

		$('.show-all').click(function(event) {
			var list = $(this).prev();
			var items = $(this).prev().children();
			var limit = list.attr('data-showmore-items-limit');

            var moreText = ( list.attr('data-showmore-text') ? list.attr('data-showmore-text') : "Show more");
            var lessText = ( list.attr('data-showless-text') ? list.attr('data-showless-text') : "Show less");

			if (list.hasClass('collapsed')) {
				list.removeClass('collapsed')
				list.addClass('expanded')

				$(this).text(lessText);

				for (var i = 0; i < items.length; i++) {
					items[i].classList.remove('hidden');
				}
			}
			else {
				list.removeClass('expanded')
				list.addClass('collapsed')

				$(this).text(moreText);

				for (var i = 0; i < items.length; i++) {
					if (i >= limit) {
						items[i].classList.add('hidden');
					}
				}
			}

		});
	}
})
